"use client";

import { FC } from "react";
import Link from "next/link";
import NavData from '@/../public/data/landing.json';

type DrawerProps = {
    isOpen: boolean;
    onClose: () => void;
};

const MobileDrawer: FC<DrawerProps> = ({ isOpen, onClose }) => {
const {header}=NavData;
    return (
        <>
            {/* Overlay */}
            <div
                className={`fixed inset-0 z-40 bg-black/40 transition-opacity duration-300 ${
                    isOpen ? "opacity-100 visible" : "opacity-0 invisible"
                }`}
                onClick={onClose}
            />

            {/* Drawer */}
            <aside
                className={`fixed top-0 right-0 z-51 h-full w-80 bg-white shadow-xl transition-transform duration-300 ${
                    isOpen ? "translate-x-0" : "translate-x-full"
                }`}
            >
                <div className="flex h-full flex-col">
                    {/* Header */}
                    <div className="flex items-center justify-between border-b p-4">
                        <h2 className="text-lg font-semibold">منو</h2>
                        <button
                            onClick={onClose}
                            className="text-gray-500 hover:text-black transition"
                            aria-label="close drawer"
                        >
                            ✕
                        </button>
                    </div>

                    {/* Links */}
                    <nav className="flex-1 overflow-y-auto p-4 space-y-2">
                        {header.nav.links
                            .filter((link) => link.state === "enabled")
                            .map((link) => (
                                <div key={link.id} className="border-b pb-2">
                                    <Link
                                        href={link.link}
                                        onClick={onClose}
                                        className="block py-2 font-medium hover:text-blue-600 transition"
                                    >
                                        {link.title}
                                    </Link>
                                </div>
                            ))}
                    </nav>

                    {/* Support */}
                    <div className="border-t p-4 text-sm text-gray-600" >
                        پشتیبانی:{" "}
                        <a
                            dir="ltr"
                            href={`tel:${header.nav.support}`}
                            className="font-semibold hover:text-blue-600 transition"
                        >
                            {header.nav.support}
                        </a>
                    </div>
                </div>
            </aside>
        </>
    );
};

export default MobileDrawer;
